import { useEffect, useState } from "react";
import { subscribeToast } from "./toastStore";
import ToastMsg from "./toast.jsx";

export default function GlobalToastHost() {
  const [event, setEvent] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => subscribeToast((evt) => {
    setEvent(evt);
    setShow(true);
  }), []);

  if (!event) return null;

  return (
    <ToastMsg
      key={event.id}
      show={show}
      setShow={setShow}
      msg={event.msg}
      type={event.type}
      action={event.action}
      delay={event.delay}
    />
  );
}
